import { Injectable } from '@angular/core';
import { CanMatch } from '@angular/router';
import { AuthenticationService } from '../data/authentication';

@Injectable({ providedIn: 'root' })
export class LoggedInGuard implements CanMatch {
  constructor(private authenticationService: AuthenticationService) {}

  public canMatch(): boolean {
    return this.authenticationService.isLoggedIn();
  }
}
